// Diálogos nativos (<dialog>) con el mismo comportamiento que el portal actual (ContactWorkspace.razor.js show/close):
// modal, el foco vuelve a quien lo abrió, en escritorio con puntero fino el foco va al primer control y un clic fuera del
// recuadro cierra.

const returnFocus = new WeakMap<HTMLDialogElement, Element | null>();
const outside = new WeakMap<HTMLDialogElement, (event: MouseEvent) => void>();

export function showDialog(dialog: HTMLDialogElement | null): void {
  if (!dialog?.isConnected) return;
  returnFocus.set(dialog, document.activeElement);
  if (!dialog.open) dialog.showModal();
  dialog.addEventListener("close", () => (returnFocus.get(dialog) as HTMLElement | null)?.focus?.(), { once: true });
  if (matchMedia("(pointer:fine)").matches && matchMedia("(min-width:768px)").matches)
    dialog.querySelector<HTMLElement>("button,input,select,textarea")?.focus();
  if (!outside.has(dialog)) {
    const onClick = (event: MouseEvent) => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom
      )
        dialog.close();
    };
    outside.set(dialog, onClick);
    dialog.addEventListener("click", onClick);
  }
}

export function closeDialog(dialog: HTMLDialogElement | null): void {
  if (dialog?.open) dialog.close();
}
